export default __webpack_public_path__ + "static/media/adventure-activity.2dc7e955.svg";